var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundHomepageDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3840 2160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_2);}.cls-2{fill:#458b8b;}.cls-3{fill:#539190;}.cls-4{fill:#5b9797;}.cls-5{fill:#679fa0;}.cls-6{fill:#73a6a7;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: 3469.66,
    y1: 1567.93,
    x2: 3469.66,
    y2: 2162,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2162)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#438989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeced"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3109,0h731V587.05a84.68,84.68,0,0,1-55,4.26c-29.35-7.8-63.3-51.17-73.7-63.9C3694,506.06,3683.44,490.26,3679,484c-12.61-17.68-35.41-40.85-80.09-63.05a223.37,223.37,0,0,0-53.26-16.19c-29-5-47.45-2.13-82.64-1.7a738.4,738.4,0,0,1-79.67-3.41,102.66,102.66,0,0,1-63.47-32.37,193.44,193.44,0,0,1-20.45-29c-20.62-35.79-16.23-54.92-35.36-89.47-10.4-18.78-21.56-30.93-31.53-41.75-21.38-23.26-30.46-23.9-60.07-49-27.81-23.56-46.13-39-59.64-66.46C3107,79.75,3096.52,57.85,3100,29.82A94.43,94.43,0,0,1,3109,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3465.19,
    cy: 597.4,
    r: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3465.19,
    cy: 554.93,
    r: 2.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3465.19,
    cy: 509.77,
    r: 2.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3465.19,
    cy: 467.72,
    r: 2.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 3465.19,
    cy: 425.55,
    r: 2.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3504.43,
    cy: 597.4,
    r: 2.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3504.43,
    cy: 554.93,
    r: 2.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3504.43,
    cy: 509.77,
    r: 2.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3504.43,
    cy: 467.72,
    r: 2.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 3504.43,
    cy: 425.55,
    r: 2.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3541.92,
    cy: 597.4,
    r: 2.3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3541.92,
    cy: 554.93,
    r: 2.3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3541.92,
    cy: 509.77,
    r: 2.3
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3541.92,
    cy: 467.72,
    r: 2.3
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 3541.92,
    cy: 425.55,
    r: 2.3
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3582.22,
    cy: 597.4,
    r: 2.3
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3582.22,
    cy: 554.93,
    r: 2.3
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3582.22,
    cy: 509.77,
    r: 2.3
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3582.22,
    cy: 467.72,
    r: 2.3
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3624.69,
    cy: 597.4,
    r: 2.3
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3624.69,
    cy: 554.93,
    r: 2.3
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3624.69,
    cy: 509.77,
    r: 2.3
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3624.69,
    cy: 467.72,
    r: 2.3
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3666.31,
    cy: 597.4,
    r: 2.3
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3665.42,
    cy: 554.93,
    r: 2.3
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3665.42,
    cy: 509.77,
    r: 2.3
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3702.4,
    cy: 597.4,
    r: 2.3
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3702.4,
    cy: 554.93,
    r: 2.3
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3741.51,
    cy: 597.4,
    r: 2.3
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3785.98,
    cy: 597.4,
    r: 2.3
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3830.88,
    cy: 597.4,
    r: 2.3
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3425.23,
    cy: 597.7,
    r: 2.3
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3425.23,
    cy: 555.23,
    r: 2.3
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3425.23,
    cy: 510.07,
    r: 2.3
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3425.23,
    cy: 468.02,
    r: 2.3
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 3425.23,
    cy: 425.85,
    r: 2.3
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3582.18,
    cy: 425.46,
    r: 2.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundHomepageDesktop);
export default __webpack_public_path__ + "static/media/background_homepage_desktop.762d73a96db7f81029dd552f666d714f.svg";
export { ForwardRef as ReactComponent };